import * as React from "react";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import {Icon} from "../../../../hiberUiKit/src/atoms/Icon/Icon";
import DropDownWrapper from "../../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import DropDownList from "../../../../hiberUiKit/src/molecules/DropDownList/DropDownList";
import IconLarge from "../../../../hiberUiKit/src/atoms/Icon/IconLarge";
import Filter from "../../../../model/workspace/Filter";

import "./addFilterButton.scss"

interface IState {
	dropDownMenuVisible: boolean
}

interface IProps {
	filters: Filter[];
	onSelect: (filter: Filter) => void
}

export default class AddFilterButton extends React.Component<IProps, IState> {

	constructor(props: IProps) {
		super(props);
		this.state = {dropDownMenuVisible: false};
	}

	render() {
		return (
			<div className={"c-add-filter reset-dropdown-right"}>
				<ButtonPrimary label={"Add filter"} onClick={() => this.setState({dropDownMenuVisible: true})}
							   prependIcon={Icon.Filter}
							   variant={this.state.dropDownMenuVisible ? "blue" : "lighter-blue"}
							   iconVariant={this.state.dropDownMenuVisible ? "white" : "blue"}/>
				{this.state.dropDownMenuVisible &&
				<DropDownWrapper onOutsideClick={() => this.setState({dropDownMenuVisible: false})}>
					<DropDownList items={this.props.filters}
								  onSelect={(item: Filter) => this.setState({dropDownMenuVisible: false},
									  () => this.props.onSelect(item))}
								  itemToId={(i: Filter) => i.id}
								  itemToLabel={this.renderItem}/>
				</DropDownWrapper>}
			</div>
		)
	}

	renderItem(item: Filter) {
		return (
			<div className="c-add-filter_item-label">
				{item.columnDefinition.label}
				<IconLarge icon={Icon.Add}/>
			</div>
		)
	}
}
